// extracted by mini-css-extract-plugin
module.exports = {"header":"Header_header__1JP3x","logo":"Header_logo__guKFR","navigation":"Header_navigation__JIgfr"};